import { Box } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const PlanCardContainer = styled(Box)`
  border-radius: 24px;
  overflow: hidden;
  margin-bottom: 20px;
`;

export const TopSection = styled(Box)<{ isDashcamPlan?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 5;
  ${props => !props.isDashcamPlan && `
    border: 1px solid var(--Border-Disabled-grey50, #F5F5F5);
    border-radius: 24px 24px 0 0;
  `}
`;

export const BackgroundImage = styled(Box)<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
`;

export const BackgroundVideo = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow: hidden;
`;

export const OverlayText = styled(Text)`
  position: relative;
  z-index: 2;
  border-radius: 0 0 8px 8px;
  background: rgba(4, 2, 34, 0.50);
  color: white;
  padding: 4px 16px;
  border-radius: 0 0 8px 8px;
  font-family: "Euclid Circular B";
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  align-self: center;
  white-space: nowrap;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 768px) {
    font-size: 14px;
    padding: 10px 20px;
  }
`;

export const PlanDetails = styled(Box)`
  position: relative;
  z-index: 2;
  padding: 20px 16px 44px 16px;
  width: auto;
`;

export const PlanName = styled(Text)<{ isDashcamPlan?: boolean }>`
  font-family: "Euclid Circular B";
  font-size: 20px;
  font-weight: 600;
  color: white;
  line-height: 1.2;
  ${props => !props.isDashcamPlan && `
    color: var(--Purple-P500, #451999);
    font-family: "Euclid Circular B";
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.1px;
  `}
  @media (min-width: 768px) {
    font-size: 28px;
  }
`;

export const PlanDescription = styled(Text)<{ isDashcamPlan?: boolean }>`
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 8px;
  line-height: 1.4;
  ${props => !props.isDashcamPlan && `
    color: var(--Neutral-N500, #36354C);
    font-family: "Euclid Circular B";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  `}
`;

export const PlanPrice = styled(Text)<{ isDashcamPlan?: boolean }>`
  color: var(--Text-White, #FFF);
  font-family: "Euclid Circular B";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; 
  ${props => !props.isDashcamPlan && `
    color: var(--text-primary-n-600, #040222);
    font-family: "Euclid Circular B";
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; 
    letter-spacing: -0.1px;
  `}
`;

export const CtaButton = styled.button`
  position: relative;
  z-index: 2;
  border-radius: 12px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-end;
  min-width: 120px;
  color: var(--text-primary-n-600, #040222);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border-radius: 8px;
  border: 1px solid #FFF;
  background: #FFF;
  &:hover {
    background: #f8f9fa;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const DescriptionPrice = styled(Box)<{ isDashcamPlan?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const InfoCTA = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 16px;
`;

export const PriceWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 2px;
`;

export const StrikethroughPrice = styled(Text)`
  color: var(--Text-Disabled-grey200, #A6A6A6);
  font-size: 14px;
  font-weight: 500;
  text-decoration: line-through;
  margin-top: 4px;
`;